/* Product gallery: thumbnails switch the stage image; on a mouse-driven
   screen a magnifier follows the cursor over the stage (a lens on the
   small image, the source pixels in a pane beside the gallery, enabled
   only when the source is at least 1.5× the painted size); the zoom button
   or a click on the image opens the full-screen viewer (<dialog>, see
   stoklink-product-lightbox), which zooms to the source pixels on click or
   double tap, pans by drag, pinches, zooms with the wheel, swipes and
   arrows between images, and keeps the stage on the image it closed on.
   Every visible string comes from data attributes written by Liquid. */
(function () {
  'use strict';

  var root = document.querySelector('[data-product]');
  if (!root) return;

  var section = root.closest('.shopify-section') || document;
  var stage = root.querySelector('[data-gallery-stage]');
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-item]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
  if (!stage || !items.length) return;

  var current = 0;
  items.forEach(function (item, i) {
    if (!item.hidden) current = i;
  });

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function focusElement(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (error) {
      el.focus();
    }
  }

  /* ---------- Stage and thumbnails ---------- */
  function select(index) {
    index = ((index % items.length) + items.length) % items.length;
    current = index;
    var id = items[index].getAttribute('data-gallery-item');
    items.forEach(function (item, i) {
      item.hidden = i !== index;
    });
    thumbs.forEach(function (thumb) {
      thumb.setAttribute('aria-pressed', thumb.getAttribute('data-gallery-thumb') === id ? 'true' : 'false');
    });
    hideMagnifier();
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var id = thumb.getAttribute('data-gallery-thumb');
      items.forEach(function (item, i) {
        if (item.getAttribute('data-gallery-item') === id) select(i);
      });
    });
  });

  function stageImage(index) {
    return items[index].querySelector('img');
  }

  function zoomSource(index) {
    var item = items[index];
    return {
      src: item.getAttribute('data-zoom-src') || '',
      width: parseInt(item.getAttribute('data-zoom-width'), 10) || 0,
      height: parseInt(item.getAttribute('data-zoom-height'), 10) || 0
    };
  }

  /* Painted area of an object-fit: contain image, in viewport coordinates. */
  function paintedRect(img) {
    var box = img.getBoundingClientRect();
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    if (!nw || !nh || !box.width || !box.height) return null;
    var scale = Math.min(box.width / nw, box.height / nh);
    var w = nw * scale;
    var h = nh * scale;
    return { left: box.left + (box.width - w) / 2, top: box.top + (box.height - h) / 2, width: w, height: h };
  }

  /* ---------- Magnifier (mouse only) ---------- */
  var MIN_MAGNIFY = 1.5;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var lens = root.querySelector('[data-gallery-lens]');
  var pane = root.querySelector('[data-gallery-pane]');
  var paneSource = '';

  function hideMagnifier() {
    if (lens) lens.hidden = true;
    if (pane) pane.hidden = true;
  }

  function moveMagnifier(event) {
    if (!lens || !pane || !fine.matches || event.pointerType !== 'mouse') return;
    var img = stageImage(current);
    if (!img || !img.complete) return hideMagnifier();
    var painted = paintedRect(img);
    var source = zoomSource(current);
    if (!painted || !source.src || !source.width) return hideMagnifier();
    var factor = source.width / painted.width;
    if (factor < MIN_MAGNIFY) return hideMagnifier();

    if (paneSource !== source.src) {
      paneSource = source.src;
      pane.style.backgroundImage = 'url("' + source.src + '")';
    }
    pane.hidden = false;
    lens.hidden = false;

    var paneW = pane.offsetWidth;
    var paneH = pane.offsetHeight;
    var lensW = Math.min(painted.width, paneW / factor);
    var lensH = Math.min(painted.height, paneH / factor);
    var x = clamp(event.clientX - painted.left - lensW / 2, 0, painted.width - lensW);
    var y = clamp(event.clientY - painted.top - lensH / 2, 0, painted.height - lensH);

    var stageBox = stage.getBoundingClientRect();
    lens.style.left = (painted.left - stageBox.left + x) + 'px';
    lens.style.top = (painted.top - stageBox.top + y) + 'px';
    lens.style.width = lensW + 'px';
    lens.style.height = lensH + 'px';

    /* A source narrower than the pane sits centred; the lens then spans the whole painted width. */
    var zoomedW = painted.width * factor;
    var zoomedH = painted.height * factor;
    pane.style.backgroundSize = zoomedW + 'px ' + zoomedH + 'px';
    pane.style.backgroundPosition = (Math.max(0, (paneW - zoomedW) / 2) - x * factor) + 'px ' + (Math.max(0, (paneH - zoomedH) / 2) - y * factor) + 'px';
  }

  if (lens && pane) {
    stage.addEventListener('pointerenter', moveMagnifier);
    stage.addEventListener('pointermove', moveMagnifier);
    stage.addEventListener('pointerleave', hideMagnifier);
    window.addEventListener('scroll', hideMagnifier, { passive: true });
    fine.addEventListener('change', hideMagnifier);
  }

  /* ---------- Lightbox ---------- */
  var dialog = section.querySelector('[data-lightbox]');
  var openButton = stage.querySelector('[data-gallery-open]');
  if (!dialog || typeof dialog.showModal !== 'function') {
    if (openButton) openButton.hidden = true;
    return;
  }
  stage.classList.add('has-lightbox');

  var view = dialog.querySelector('[data-lightbox-view]');
  var image = dialog.querySelector('[data-lightbox-image]');
  var counter = dialog.querySelector('[data-lightbox-counter]');
  var zoomButton = dialog.querySelector('[data-lightbox-zoom]');
  var closeButton = dialog.querySelector('[data-lightbox-close]');
  var prevButton = dialog.querySelector('[data-lightbox-prev]');
  var nextButton = dialog.querySelector('[data-lightbox-next]');
  var caption = dialog.querySelector('[data-lightbox-caption]');
  var counterTemplate = dialog.getAttribute('data-counter') || '[n] / [total]';
  var labelActual = dialog.getAttribute('data-zoom-in') || '';
  var labelFit = dialog.getAttribute('data-zoom-out') || '';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var shown = -1;
  var scale = 1;
  var tx = 0;
  var ty = 0;
  var maxScale = 1;
  var lastTrigger = null;

  function fitWidth() {
    return image.offsetWidth;
  }
  function fitHeight() {
    return image.offsetHeight;
  }

  function measure() {
    var source = zoomSource(shown);
    var fw = fitWidth();
    maxScale = fw && source.width ? clamp(source.width / fw, 1, 6) : 1;
    var zoomable = maxScale > 1.1;
    if (zoomButton) zoomButton.hidden = !zoomable;
    view.classList.toggle('is-fixed', !zoomable);
  }

  function clampOffsets() {
    var vw = view.clientWidth;
    var vh = view.clientHeight;
    var ox = image.offsetLeft;
    var oy = image.offsetTop;
    var w = fitWidth() * scale;
    var h = fitHeight() * scale;
    tx = w <= vw ? (vw - w) / 2 - ox : clamp(tx, vw - ox - w, -ox);
    ty = h <= vh ? (vh - h) / 2 - oy : clamp(ty, vh - oy - h, -oy);
  }

  function apply() {
    clampOffsets();
    image.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
    var zoomed = scale > 1.01;
    view.classList.toggle('is-zoomed', zoomed);
    if (zoomButton) {
      zoomButton.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
      zoomButton.textContent = zoomed ? labelFit : labelActual;
    }
  }

  /* Zoom to `next` keeping the image point under (cx, cy) — view
     coordinates — where it is. */
  function zoomAt(next, cx, cy) {
    next = clamp(next, 1, maxScale);
    var ox = image.offsetLeft;
    var oy = image.offsetTop;
    var px = (cx - ox - tx) / scale;
    var py = (cy - oy - ty) / scale;
    scale = next;
    tx = cx - ox - px * scale;
    ty = cy - oy - py * scale;
    apply();
  }

  function animateTo(next, cx, cy) {
    if (!reduceMotion.matches) {
      image.classList.add('is-animating');
      window.setTimeout(function () {
        image.classList.remove('is-animating');
      }, 220);
    }
    zoomAt(next, cx, cy);
  }

  function toggleZoom(cx, cy) {
    if (maxScale <= 1.1) return;
    if (cx === undefined) {
      cx = view.clientWidth / 2;
      cy = view.clientHeight / 2;
    }
    animateTo(scale > 1.01 ? 1 : maxScale, cx, cy);
  }

  function resetZoom() {
    scale = 1;
    tx = 0;
    ty = 0;
    apply();
  }

  function preload(index) {
    var source = zoomSource(((index % items.length) + items.length) % items.length);
    if (source.src) new Image().src = source.src;
  }

  function show(index) {
    index = ((index % items.length) + items.length) % items.length;
    shown = index;
    var source = zoomSource(index);
    var stageImg = stageImage(index);
    image.classList.add('is-loading');
    image.width = source.width;
    image.height = source.height;
    image.alt = stageImg ? stageImg.alt : '';
    image.src = source.src;
    if (image.complete && image.naturalWidth) onLoad();
    if (counter) counter.textContent = counterTemplate.replace('[n]', String(index + 1)).replace('[total]', String(items.length));
    if (caption) caption.textContent = image.alt;
    select(index);
    if (items.length > 1) {
      preload(index + 1);
      preload(index - 1);
    }
  }

  function onLoad() {
    image.classList.remove('is-loading');
    measure();
    resetZoom();
  }

  image.addEventListener('load', onLoad);
  image.addEventListener('error', function () {
    image.classList.remove('is-loading');
  });

  function open(index, trigger) {
    lastTrigger = trigger || openButton;
    hideMagnifier();
    document.documentElement.classList.add('is-locked');
    if (!dialog.open) dialog.showModal();
    show(index);
    focusElement(closeButton);
  }

  function close() {
    if (dialog.open) dialog.close();
  }

  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('is-locked');
    if (lastTrigger && document.contains(lastTrigger)) focusElement(lastTrigger);
    lastTrigger = null;
  });

  stage.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-gallery-open]');
    if (!button && !target.closest('.product__image')) return;
    open(current, button || openButton);
  });

  if (closeButton) closeButton.addEventListener('click', close);
  if (prevButton) prevButton.addEventListener('click', function () { show(shown - 1); });
  if (nextButton) nextButton.addEventListener('click', function () { show(shown + 1); });
  if (zoomButton) zoomButton.addEventListener('click', function () { toggleZoom(); });

  dialog.addEventListener('keydown', function (event) {
    var rtl = (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
    var step = 0;
    if (event.key === 'ArrowLeft') step = rtl ? 1 : -1;
    if (event.key === 'ArrowRight') step = rtl ? -1 : 1;
    if (step && items.length > 1) {
      event.preventDefault();
      show(shown + step);
      return;
    }
    if (event.key === '+' || event.key === '=') {
      event.preventDefault();
      animateTo(scale * 1.5, view.clientWidth / 2, view.clientHeight / 2);
    } else if (event.key === '-' || event.key === '_') {
      event.preventDefault();
      animateTo(scale / 1.5, view.clientWidth / 2, view.clientHeight / 2);
    }
  });

  /* Pointer gestures on the view: drag pans when zoomed, two pointers pinch,
     a tap on the image toggles (mouse: single click, touch: double tap), a
     tap beside it closes, a horizontal swipe at fit size changes image. */
  var pointers = {};
  var pointerCount = 0;
  var drag = null;
  var pinch = null;
  var moved = false;
  var lastTap = 0;

  function pointerList() {
    return Object.keys(pointers).map(function (id) { return pointers[id]; });
  }

  function viewPoint(clientX, clientY) {
    var box = view.getBoundingClientRect();
    return { x: clientX - box.left, y: clientY - box.top };
  }

  function distance(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
  }

  function startPinch() {
    var pts = pointerList();
    var mid = viewPoint((pts[0].x + pts[1].x) / 2, (pts[0].y + pts[1].y) / 2);
    pinch = {
      dist: Math.max(1, distance(pts[0], pts[1])),
      scale: scale,
      px: (mid.x - image.offsetLeft - tx) / scale,
      py: (mid.y - image.offsetTop - ty) / scale
    };
    drag = null;
  }

  view.addEventListener('pointerdown', function (event) {
    if (event.button !== 0 && event.pointerType === 'mouse') return;
    event.preventDefault();
    try { view.setPointerCapture(event.pointerId); } catch (error) { /* capture is optional */ }
    if (!pointers[event.pointerId]) pointerCount++;
    pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
    if (pointerCount === 1) {
      drag = { x: event.clientX, y: event.clientY, tx: tx, ty: ty, onImage: event.target === image, type: event.pointerType };
      moved = false;
    } else if (pointerCount === 2) {
      startPinch();
      moved = true;
    }
  });

  view.addEventListener('pointermove', function (event) {
    if (!pointers[event.pointerId]) return;
    pointers[event.pointerId] = { x: event.clientX, y: event.clientY };
    if (pinch && pointerCount >= 2) {
      var pts = pointerList();
      var mid = viewPoint((pts[0].x + pts[1].x) / 2, (pts[0].y + pts[1].y) / 2);
      scale = clamp(pinch.scale * distance(pts[0], pts[1]) / pinch.dist, 1, maxScale);
      tx = mid.x - image.offsetLeft - pinch.px * scale;
      ty = mid.y - image.offsetTop - pinch.py * scale;
      apply();
      return;
    }
    if (!drag) return;
    var dx = event.clientX - drag.x;
    var dy = event.clientY - drag.y;
    if (Math.abs(dx) + Math.abs(dy) > 6) moved = true;
    if (scale > 1.01) {
      tx = drag.tx + dx;
      ty = drag.ty + dy;
      apply();
    }
  });

  function endPointer(event) {
    if (!pointers[event.pointerId]) return;
    delete pointers[event.pointerId];
    pointerCount = Math.max(0, pointerCount - 1);
    if (pinch) {
      if (pointerCount < 2) {
        pinch = null;
        if (pointerCount === 1) {
          var rest = pointerList()[0];
          drag = { x: rest.x, y: rest.y, tx: tx, ty: ty, onImage: true, type: event.pointerType };
        }
      }
      return;
    }
    if (!drag || event.type === 'pointercancel') {
      drag = null;
      return;
    }
    var dx = event.clientX - drag.x;
    var dy = event.clientY - drag.y;
    var info = drag;
    drag = null;
    if (!moved) {
      if (!info.onImage) {
        close();
        return;
      }
      var point = viewPoint(event.clientX, event.clientY);
      if (info.type === 'mouse') {
        toggleZoom(point.x, point.y);
      } else {
        var now = Date.now();
        if (now - lastTap < 320) {
          lastTap = 0;
          toggleZoom(point.x, point.y);
        } else {
          lastTap = now;
        }
      }
      return;
    }
    if (scale <= 1.01 && items.length > 1 && Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      show(dx < 0 ? shown + 1 : shown - 1);
    }
  }

  view.addEventListener('pointerup', endPointer);
  view.addEventListener('pointercancel', endPointer);

  view.addEventListener('wheel', function (event) {
    if (maxScale <= 1.1) return;
    event.preventDefault();
    var point = viewPoint(event.clientX, event.clientY);
    zoomAt(scale * (event.deltaY < 0 ? 1.15 : 1 / 1.15), point.x, point.y);
  }, { passive: false });

  window.addEventListener('resize', function () {
    if (!dialog.open) return;
    measure();
    if (scale > maxScale) scale = maxScale;
    apply();
  });
})();
